import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { fetcher } from './fetcher';

export const useTradingViewConfig = () => {
  const reactQueryOptions = useMemo(() => {
    return queryOptions({
      queryKey: getKey(),
      queryFn: getFn(),
    });
  }, []);

  return useQuery(reactQueryOptions);
};

const getKey = () => {
  return ['pyth-benchmark/config'];
};
const getFn = () => () => fetcher();
useTradingViewConfig.getQueryKey = getKey;
useTradingViewConfig.getQueryFn = getFn;
